module.exports = __webpack_public_path__ + "img/mail.3ee1ba04.svg";